interface StatsCardProps {
  title: string;
  value: string;
}

export default function StatsCard({ title, value }: StatsCardProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-4 hover:shadow-lg hover:border-gray-300 transition-all duration-200 cursor-pointer">
      <div>
          <p className="text-xs text-gray-600 mb-1">{title}</p>
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 truncate">{value}</h3>
      </div>
    </div>
  );
}
